<template>
    <v-card>
        <v-card-title class="justify-center primary" icon @click="mostrar()" style="cursor: pointer;">
            <v-toolbar-title id="titulocard">Documentos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-card-title>
        <v-expand-transition>
            <div v-show="show">
                <v-card-text style="margin-bottom: 4%;">
                    <v-row>
                        <v-col>
                            <DataTable :url="urlListado" :columns="columns" :params="displayInputs" :order="[]"
                                :formatterActions="formatterActions" @apiDT="apiDT = $event" :movil="false"
                                @Cancelar="CancelarShow"></DataTable>
                        </v-col>
                    </v-row>
                    <div v-show="showLightbox">
                        <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                            @onClosed="CerrarVisor()" />
                    </div>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card-text>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Archivos from '@/services/documentos/documentos.service.js';
import LightBox from '@/components/pages/Visor/LightBox.vue';
import Inicio from '@/services/main/main.service.js';


export default {
    components: {
        DataTable, LightBox
    },
    data: function () {
        return {
            show: true,
            cargando: false,
            urlListado: 'Documentos/ArchivosDocumentos',
            apiDT: null,
            columns: [
                { name: 'doiniciales', data: 'doiniciales', title: 'Iniciales' },
                { name: 'dodescrip', data: 'dodescrip', title: 'Descripción' },
                { name: 'docbaja', data: 'docbaja', title: 'Fecha expiración' },
                { name: 'vcuslogin', data: 'vcuslogin', title: 'Usuario Compartió' },
                { name: 'docid', data: 'docid', title: "", formatter: [this, "verDocumento"], orderable: false },
                { name: "ddocid", data: "docid", title: "", formatter: [this, "Descargar_Archivo"], orderable: false },
            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            },
            formatterActions: [
                { click: [this, "VerArchivo"] },
                { click: [this, "DescargarArchivo"] },
            ],
            showLightbox: false,
            overlay: false,
            isPDF: false,
            media: [{
                src: '@/',
                type: ''
            }],
            permisoexcel: false
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async mounted() {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.displayInputs = {
            nrreporte: datos.nrreporte,
            svindice: datos.svindice,
            aiclave: datos.aiclave
        };

        await Inicio.VerificarPermisos(this, "348").then(data => {
            if (data.length > 0)
                this.permisoexcel = true;
        });

        this.reloadTable();
    },
    methods: {
        mostrar() {
            if (this.show == true) {
                this.show = false;
                this.Documentos = [];
            } else {
                this.show = true;
                this.cargando = false;
            }
        },
        CancelarShow() {
            this.cargando = false;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        verDocumento(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.docid}" title="Ver Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-eye theme--dark"></i></span></button></div>` : ``;
        },
        Descargar_Archivo(datos) {
            if (this.permisoexcel) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small info dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.docid}" title="Descargar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-download-outline theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        async VerArchivo(params, datos) {
            this.showLightbox = false;
            this.overlay = true;
            this.media = this.media.filter(obj => obj.src == '@/');
            this.isPDF = /\.pdf$/i.test(datos.docarchivo);
            let dir = await Archivos.ObtenerDireccion(this.displayInputs, datos.docid, 1);

            var formData = new FormData();
            formData.append("lasitio", 'Siniestros');
            formData.append("lomodulo", 'Documentos');
            formData.append("laaccion", "Vio Documento");
            formData.append("lacaracteristicas", this.displayInputs.nrreporte + '-' + this.displayInputs.svindice);
            formData.append("lanombre", dir.archivo);
            formData.append("ladestinatario", "");
            await Archivos.AlmacenarVisitas(formData);
            if (dir.archivo !== null) {
                var img = {
                    src: dir.watch,
                    caption: '<h4>' + datos.dodescrip + '</h4>',
                    type: this.isPDF == true ? 'pdf' : 'img',
                    width: '800px',
                    docid: datos.docid,
                    paginas: datos.docpaginas
                };
                this.media.push(img);
                this.media = this.media.filter(obj => obj.src !== '@/');
                this.showLightbox = true;
            } else {
                var img = {
                    type: 'error',
                    caption: '<h4>' + datos.dodescrip + '</h4>',
                    docid: datos.docid,
                    paginas: datos.docpaginas
                };
                this.media.push(img);
                this.media = this.media.filter(obj => obj.src !== '@/');
                this.showLightbox = true;
            }
            this.overlay = false;
        },
        async CerrarVisor() {
            var img = {
                src: '@/',
                type: 'img'
            }
            this.media = [];
            this.media.push(img);
            this.showLightbox = false;
            await this.$refs.lightbox.showImage(0);
        },
        async DescargarArchivo(params, datos, fila) {
            this.$swal({
                title: 'Descargando archivo, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    var datosReporte = new FormData();
                    datosReporte.append("nrreporte", this.displayInputs.nrreporte);
                    datosReporte.append("svindice", this.displayInputs.svindice);
                    Archivos.DescargaZip(this.displayInputs, datos.docid, datos.dodescrip).then(response => {
                        if (response != null) {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.displayInputs.nrreporte + '-' + this.displayInputs.svindice + '-' + datos.dodescrip + '.zip');
                            document.body.appendChild(link);
                            link.click()
                            var formData = new FormData();
                            formData.append("lasitio", 'Prusia+');
                            formData.append("lomodulo", "Documentos");
                            formData.append("laaccion", "Descargó Documento .zip");
                            formData.append("lacaracteristicas", this.displayInputs.nrreporte + '-' + this.displayInputs.svindice);
                            formData.append("lanombre", this.displayInputs.nrreporte + '-' + this.displayInputs.svindice + '-' + datos.dodescrip + '.zip');
                            formData.append("ladestinatario", "");
                            Archivos.AlmacenarVisitas(formData).then(data => {
                            });

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Correcto',
                                text: 'Archivo descargado correctamente',
                                showConfirmButton: true,
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Correcto',
                                text: 'Ocurrio un error, intentelo más tarde!!',
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    });
                },
            });
        },
    }

}
</script>

<style></style>